module.exports = __webpack_public_path__ + "img/default-profile.18973f41.png";